module.exports = __webpack_public_path__ + "0fd80fd379c960086f2d8bc3a2ec26d8.png";